import React, { useState, useEffect } from "react";
import api from "../api/api";
import { User, Edit2 } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function ProfileCard({ userData }) {
  const [profile, setProfile] = useState(null);
  const [avatar, setAvatar] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const token = localStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        const res = await api.get("/Profile", { headers });
        setProfile(res.data);
        if (res.data.avatar) {
          setAvatar(`${process.env.REACT_APP_API_URL}/uploads/avatar/${res.data.avatar}`);
        }
      } catch (err) {
        console.error("Failed to fetch profile", err);
      }
    };

    fetchProfile();
  }, []);

  const handleAvatarChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("avatar", file);

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const res = await api.post("/profile/avatar", formData, { headers });
      setAvatar(res.data.avatarUrl);
    } catch (err) {
      console.error("Failed to upload avatar", err);
    }
  };

  return (
    <div className="flex items-center gap-4 p-4 bg-white rounded shadow">
      <div className="relative">
        {avatar ? (
          <img
            src={avatar}
            alt="Avatar"
            className="w-16 h-16 rounded-full object-cover"
          />
        ) : (
          <div className="w-16 h-16 rounded-full bg-gray-200 flex items-center justify-center">
            <User className="w-8 h-8 text-gray-500" />
          </div>
        )}

        <label className="absolute bottom-0 right-0 bg-blue-500 text-white p-1 rounded-full cursor-pointer">
          <Edit2 className="w-4 h-4" />
          <input
            type="file"
            accept="image/*"
            className="hidden"
            onChange={handleAvatarChange}
          />
        </label>
      </div>

      <div>
        <h3 className="font-semibold">{userData.name}</h3>
        <p className="text-sm text-gray-600">{userData.email}</p>
        {profile && profile.title && (
          <p className="text-sm text-gray-800">{profile.title}</p>
        )}
        <button
          onClick={() => navigate("/profile-setup")}
          className="text-sm text-blue-500 mt-1"
        >
          Edit / Complete Profile
        </button>
      </div>
    </div>
  );
}
